<template>
  <Stage class="instructions">
    <template #header>
      <h1>{{ trialData.body.headline.text }}</h1>
    </template>
    <InstructionsContainer>
      <div v-html="renderMarkdown(trialData.body.content.text)" />
    </InstructionsContainer>
  </Stage>
</template>
<script>
import essComponentProps from '@/mixins/essComponentProps'
import { Stage } from '@neurotrack/web-shared-components'
import InstructionsContainer from '@/components/InstructionsContainer'

export default {
  name: 'instructions_text_only',
  mixins: [essComponentProps],
  components: {
    Stage,
    InstructionsContainer
  }
}
</script>

<style scoped>
.instructions-container,
.instructions .button-container {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}
.instructions-container ul > li {
  text-align: center;
}

.instructions .button-container button {
  margin: 1rem;
}
</style>
